import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {ZXingScannerComponent} from '@zxing/ngx-scanner';
import {AlertController, IonButton, IonSelect, ModalController} from '@ionic/angular';
import {ScreenPreferencesModel} from '../../models/screen-preferences.model';
import {BarcodeFormatModel} from '../../models/barcode-format.model';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {ScanBarcodeService} from '../../services/scan-barcode.service';
import {GeneralService} from '../../services/general.service';
import {AndroidPermissions} from '@ionic-native/android-permissions/ngx';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {DocumentFromLiveDetailLineService} from '../../services/document-from-live-detail-line.service';
import {BarcodeFormat} from '@zxing/library';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {StockTakeHelperService} from '../../services/stock-take-helper.service';

@Component({
    selector: 'app-stock-take-barcode',
    templateUrl: './stock-take-barcode.component.html',
    styleUrls: ['./stock-take-barcode.component.scss'],
})
export class StockTakeBarcodeComponent implements OnInit {

    @Input() stockCount: DocumentModel;
    @ViewChild('scanner') scanner: ZXingScannerComponent;
    @ViewChild('barcodeFormatSelect') barcodeFormatSelect: IonSelect;
    @ViewChild('torchButton') torchButton: IonButton;
    hasCameras = false;
    hasPermission: boolean;
    qrResultString: string;
    availableDevices: MediaDeviceInfo[];
    selectedDevice: MediaDeviceInfo = null;
    barcodeMediaDevices: MediaDeviceInfo[] = [];
    enabled: Boolean = false;
    screenPreferences: ScreenPreferencesModel;
    bcFormat: BarcodeFormatModel;
    allowedFormats: any = [];
    torchEnabled = false;
    mobileConfig: MobileConfigurationModel;
    willScan = true;

    constructor(public modalController: ModalController,
                private scanBarcodeService: ScanBarcodeService,
                private generalService: GeneralService,
                private alertController: AlertController,
                private androidPermissions: AndroidPermissions,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private documentFromLiveDetailLine: DocumentFromLiveDetailLineService,
                private stockTakeHelper: StockTakeHelperService) {
    }

    ngOnInit() {
        this.mobileConfig = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION);
        const productsWithBarcode = this.stateManager.getCollection(this.collectionNames.PRODUCTBARCODESTOCKTAKE).filter(prod => {
            return prod.barcode;
        });
        console.log(productsWithBarcode);
    }

    ionViewWillEnter() {
        this.screenPreferences = this.stateManager.getCollection(this.collectionNames.SCREENPREFERENCES);
    }

    ionViewDidEnter() {
        this.createBarcodeFormat();
        this.setTorchButtonColor();
    }

    isBarcodeReaderLive() {
        const interval = setInterval(() => {
            clearInterval(interval);
            this.torchEnabled = this.screenPreferences.barcodeTorchEnabled;
            console.log('interval fired');
        }, 1000);

    }


    async closeModal() {
        await this.modalController.dismiss();
    }

    onCamerasFound(devices: MediaDeviceInfo[]) {
        console.log('On Cameras found devices');
        console.log(devices);
        console.log('------------------------');

        this.barcodeMediaDevices = devices;

        this.selectCamera();
        this.isBarcodeReaderLive();
    }

    selectCamera() {
        console.log(this.screenPreferences.selectedBarcodeDevice);
        if (!this.screenPreferences.selectedBarcodeDevice) {
            this.screenPreferences.selectedBarcodeDevice = this.barcodeMediaDevices[0];
            this.stateManager.update(this.collectionNames.SCREENPREFERENCES, this.screenPreferences);
        }

        const refresh = JSON.parse(JSON.stringify(this.screenPreferences.selectedBarcodeDevice));
        this.screenPreferences.selectedBarcodeDevice = null;
        this.screenPreferences.selectedBarcodeDevice = refresh;
        this.selectedDevice = null;
        for (const device of this.barcodeMediaDevices) {
            if (device.label === this.screenPreferences.selectedBarcodeDevice.label) {
                this.selectedDevice = device;
            }
        }
        this.hasCameras = Boolean(this.barcodeMediaDevices && this.barcodeMediaDevices.length);
        this.enabled = true;
    }

    onHasPermission(has: boolean) {
        console.log('I got permission');
        this.hasPermission = has;
    }

    createBarcodeFormat() {
        for (const n in BarcodeFormat) {
            if (typeof BarcodeFormat[n] === 'string') {
                const bcFormat = {
                    description: 'BarcodeFormat.' + BarcodeFormat[n],
                    shortDescription: BarcodeFormat[n]
                };
                this.allowedFormats.push(bcFormat);
            }
        }
    }

    barcodeFormatCompare(f1: BarcodeFormatModel, f2: BarcodeFormatModel): boolean {
        return f1 && f2 ? f1.description === f2.description : f1 === f2;
    }

    onTorchCompatible(event) {

    }

    saveConfig() {
        console.log(this.screenPreferences);
        this.stateManager.update(this.collectionNames.SCREENPREFERENCES, this.screenPreferences);
        this.selectCamera();
    }

    mediaDeviceCompare(m1: MediaDeviceInfo, m2: MediaDeviceInfo): boolean {
        return m1 && m2 ? m1.label === m2.label : m1 === m2;
    }

    openBarcodeFormat() {
        this.barcodeFormatSelect.open();
    }

    handleClickingTorch() {
        this.screenPreferences.barcodeTorchEnabled = !this.screenPreferences.barcodeTorchEnabled;
        this.torchEnabled = this.screenPreferences.barcodeTorchEnabled;
        this.setTorchButtonColor();
        this.stateManager.update(this.collectionNames.SCREENPREFERENCES, this.screenPreferences);
    }

    setTorchButtonColor() {
        this.torchButton.color = this.screenPreferences.barcodeTorchEnabled ? 'primary' : 'light';
    }

    async handleScanResult(event) {
        console.log('Scan Result');
        console.log(event);
        if (this.willScan) {
            this.willScan = false;
            const stockLine = this.scanBarcodeService.findProductWithBarcode(event) as DetaillineDTOModel;
            if (stockLine) {
                this.confirmEquipment(JSON.parse(JSON.stringify(stockLine)));
            } else {
                await this.generalService.createToast('No match with barcode: ' + event);
                this.willScan = true;
            }
        }
    }

    async confirmEquipment(product) {
        const alert = await this.alertController.create({
            header: 'Equipment found',
            message: 'Please inform quantity.',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'qty',
                    type: 'number',
                    placeholder: 'Quantity'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        this.willScan = true;
                    }
                }, {
                    text: 'Yes',
                    handler: data => {
                        console.log(data.qty);
                        this.stockTakeHelper.addItemToStockCount(this.stockCount, product, data.qty);
                        this.willScan = true;
                    }
                }
            ]
        });
        await alert.present();
    }
}
